import React from 'react'

import { ProductFeatureCard } from 'components/product-feature-card/ProductFeatureCard'
import { Text, TextName } from 'sdk'
import puzzleIcon from 'shared/assets/icons/puzzle.svg'

interface IntegrationSupportCardProps {
  title: string
  body: string
  className?: string
}

export const IntegrationSupportCard: React.FC<IntegrationSupportCardProps> = ({ title, body, className }) => {
  return (
    <ProductFeatureCard
      icon={puzzleIcon}
      row={true}
      className={className}
      text={
        <>
          <Text type={TextName.TextBold}>{title}</Text>
          <Text type={TextName.Text}>{body}</Text>
        </>
      }
    />
  )
}
